import * as Styles from './styles'
import { ResumeCraftingActionButtonProps } from './types'

export const ActionButton = ({
  status,
  actionText,
  suggestion,
  onClick,
}: ResumeCraftingActionButtonProps) => {
  if (status === 'completed' || status === 'initial') {
    return (
      <Styles.ActionContainer
        data-testid={`resume-crafting-action-button-${status}`}
        onClick={onClick}
      >
        <Styles.ActionText>{actionText}</Styles.ActionText>
        <Styles.IconContainer>
          <Styles.Icon />
        </Styles.IconContainer>
      </Styles.ActionContainer>
    )
  }

  return (
    <Styles.ActionContainer
      data-testid={`resume-crafting-action-button-${status}`}
      onClick={onClick}
      $isPhone
    >
      <Styles.ActionText>{suggestion?.text}</Styles.ActionText>
      <Styles.ActionCredit>+{suggestion?.points}%</Styles.ActionCredit>
    </Styles.ActionContainer>
  )
}
